export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20artistic%20manga%20and%20comic%20illustration%20wallpaper%20with%20soft%20warm%20gradients%20from%20coral%20pink%20to%20peach%20and%20cream%2C%20stylized%20abstract%20manga%20panel%20lines%20and%20speech%20bubbles%20floating%20subtly%20in%20the%20background%2C%20clean%20minimal%20composition%20with%20plenty%20of%20empty%20space%20on%20the%20right%20side%2C%20warm%20and%20energetic%20yet%20soft%20color%20palette%2C%20no%20text%2C%20digital%20art%20style%2C%2016:9%20aspect%20ratio&width=1600&height=900&seq=hero-bg-51comic&orientation=landscape"
          alt="51漫画主视觉背景"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full pt-28 md:pt-24 pb-8 md:pb-0">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-100/80 text-accent-800 text-sm font-medium mb-6 whitespace-nowrap">
              <i className="ri-fire-line text-accent-500"></i>
              <span>每日更新 · 热门连载中</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              51漫画 · 免费漫画全集在线阅读平台
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              下拉式阅读，实时追更，海量漫画一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-lg">
              51漫画在线观看为您提供海量免费漫画全集，支持网页在线观看与下拉式阅读体验。涵盖热血、恋爱、奇幻、悬疑等全品类漫画大全，每日实时更新热门连载，无需下载即可畅享在线漫画阅读乐趣。无论是最新番剧还是经典完结作品，51漫画在线都能满足您的阅读需求。
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading text-primary-500">10万+</span>
                <span className="text-xs md:text-sm text-foreground-500">漫画资源</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading text-accent-500">每日更新</span>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading text-secondary-500">全品类</span>
                <span className="text-xs md:text-sm text-foreground-500">覆盖</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-800 font-medium rounded-full hover:bg-background-200 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer border border-background-300"
              >
                <i className="ri-fire-line text-lg text-accent-500"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center pb-8 md:pb-0">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20manga%20illustration%20showcasing%20multiple%20popular%20comic%20characters%20in%20action%20poses%20with%20vibrant%20warm%20colors%2C%20energetic%20shonen-style%20art%2C%20characters%20from%20different%20genres%20including%20romance%20and%20fantasy%2C%20clean%20composition%20with%20soft%20gradient%20background%20in%20peach%20and%20cream%20tones%2C%20modern%20digital%20illustration%20style%2C%20Japanese%20manga%20aesthetic%2C%20no%20text&width=480&height=600&seq=hero-main-visual&orientation=portrait"
                alt="51漫画 - 免费漫画在线阅读主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/40 to-transparent h-24"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}